import React from 'react';
import {ClassroomCodeStatusEnum} from "@/lib/helper/enumType";

function ClassroomStatusEnumComponent({text}) {

    if (!text || text === 'none') {
        return <span></span>
    } else {
        return <> <i className={`${ClassroomCodeStatusEnum(text, `color`)}`}></i>
            <span className={ClassroomCodeStatusEnum(text, `color`)}>{ClassroomCodeStatusEnum(text)}</span></>
    }

}

export default ClassroomStatusEnumComponent;